/**
 * De vaste knoppen van de publieke pagina's (docs/VORMGEVING.md › Pagina's en › Woorden): per
 * pagina één vraag, één hoofdknop. De woorden staan hier op één plek, zodat "kiezen" en "een
 * afspraak plannen" op elke pagina hetzelfde heten.
 */
export const pageActions = {
  /** Home en Webshop: naar de keuze per huidvraag. */
  chooseByConcern: 'Kies op je huidvraag',
  /** Protocollen: naar de protocollen per klacht. */
  startProtocol: 'Begin met je protocol',
  /** Journal: het nieuwste artikel. */
  readLatest: 'Lees het nieuwste artikel',
  /** Over: naar de webshop. */
  viewCollection: 'Bekijk de collectie',
  /** Artikel: naar wat in het artikel genoemd wordt. */
  viewMentioned: (name: string) => `Bekijk ${name}`,
  /** Artikel zonder genoemd product: altijd een volgende stap. */
  viewProtocols: 'Bekijk de protocollen',
  /** Elke boekknop. In de lade kies je de behandeling of het consult. */
  book: 'Plan een afspraak',
  /** De online vragenlijst. */
  quiz: 'Huidtest',
} as const

/** Kop boven de veelgestelde vragen over bestellen: één formulering op Webshop en Protocollen. */
export const shopFaqTitle = 'Bestellen, ruilen en bijvullen'
